import type { IAsset } from '~/types/assets-management'

import { ASSET_STATUS } from '~/types/assets-management'

export const assetMock: IAsset = {
  created_at: 1667484510376,
  created_by: 'ios-builder',
  custom_digest: 'e29f0e0f6cf2e6433621380c3ff40f91',
  expiration_date: null,
  file_type: 'Image',
  files: [
    {
      bucket: 'mwm-asset-bucket-europe-west1',
      created_at: 1667484266915,
      created_by: 'ios-builder',
      download_url: 'https://cdn.mwm-asset-manager.mwmwebapis.com/0f40b046-ec00-4b94-83c1-2f51e8447762',
      id: '0f40b046-ec00-4b94-83c1-2f51e8447762',
      mime_type: 'image/png',
      name: 'icone_procolor~UIAppearanceAny~phone@3x.png',
      path: '0f40b046-ec00-4b94-83c1-2f51e8447762',
      quality_identifier: '3',
      size: 75533,
      status: 'ready',
      storage: 'gcs',
      updated_at: 1667484266916,
      updated_by: 'ios-builder',
    },
    {
      bucket: 'mwm-asset-bucket-europe-west1',
      created_at: 1667484631390,
      created_by: 'ios-builder',
      download_url: 'https://cdn.mwm-asset-manager.mwmwebapis.com/16fd5e17-3704-4e69-b62e-df3d3d2c91d6',
      id: '16fd5e17-3704-4e69-b62e-df3d3d2c91d6',
      mime_type: 'image/png',
      name: 'icone_procolor~UIAppearanceAny~phone@2x.png',
      path: '16fd5e17-3704-4e69-b62e-df3d3d2c91d6',
      quality_identifier: '2',
      size: 36893,
      status: 'ready',
      storage: 'gcs',
      updated_at: 1667484631390,
      updated_by: 'ios-builder',
    },
    {
      bucket: 'mwm-asset-bucket-europe-west1',
      created_at: 1667484804032,
      created_by: 'ios-builder',
      download_url: 'https://cdn.mwm-asset-manager.mwmwebapis.com/e882dd5d-517a-46ee-a699-42f9d150bb6e',
      id: 'e882dd5d-517a-46ee-a699-42f9d150bb6e',
      mime_type: 'image/png',
      name: 'icone_procolor~UIAppearanceAny~phone.png',
      path: 'e882dd5d-517a-46ee-a699-42f9d150bb6e',
      quality_identifier: '1',
      size: 11924,
      status: 'ready',
      storage: 'gcs',
      updated_at: 1667484804032,
      updated_by: 'ios-builder',
    },
    {
      bucket: 'mwm-asset-bucket-europe-west1',
      created_at: 1667483963317,
      created_by: 'ios-builder',
      download_url: 'https://cdn.mwm-asset-manager.mwmwebapis.com/41481140-62d6-454d-a3bb-20f7955d860f',
      id: '41481140-62d6-454d-a3bb-20f7955d860f',
      mime_type: 'image/png',
      name: 'icone_procolor~UIAppearanceAny~pad.png',
      path: '41481140-62d6-454d-a3bb-20f7955d860f',
      quality_identifier: '1',
      size: 29826,
      status: 'ready',
      storage: 'gcs',
      updated_at: 1667483963317,
      updated_by: 'ios-builder',
    },
    {
      bucket: 'mwm-asset-bucket-europe-west1',
      created_at: 1667484113957,
      created_by: 'ios-builder',
      download_url: 'https://cdn.mwm-asset-manager.mwmwebapis.com/186b93b5-84a9-4e58-8d64-57df71732329',
      id: '186b93b5-84a9-4e58-8d64-57df71732329',
      mime_type: 'image/png',
      name: 'icone_procolor~UIAppearanceAny~pad@2x.png',
      path: '186b93b5-84a9-4e58-8d64-57df71732329',
      quality_identifier: '2',
      size: 102721,
      status: 'ready',
      storage: 'gcs',
      updated_at: 1667484113957,
      updated_by: 'ios-builder',
    },
  ],
  id: '23233b70-c68d-4334-9419-e8156c2937be',
  name: 'icone_procolor',
  status: ASSET_STATUS.RELEASED,
  tags: [
    {
      asset_id: '23233b70-c68d-4334-9419-e8156c2937be',
      key: 'publishing_sample',
      value: ['1.00.00'],
    },
  ],
  updated_at: 1667484510376,
  updated_by: 'ios-builder',
}
